import { AsyncPipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { TaskCategoryService } from '@fitness-force/api';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from '@fitness-force/state';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';

@Component({
  selector: 'task-category-cell',
  templateUrl: './task-category-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class TaskCategoryCellComponent implements OnInit {
  private store = inject(Store);
  private taskCategoryService = inject(TaskCategoryService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  dataProperty: string = '';
  taskCategory: BehaviorSubject<any> = new BehaviorSubject(null);

  ngOnInit(): void {
    combineLatest([this.store.select(TENANTS_INFO), this.columnData]).subscribe(
      ([tenant, colData]) => {
        const tenantId = tenant.selected_tenant.id;
        this.taskCategoryService
          .getTaskCategory(tenantId)
          .subscribe((taskCategories: any) => {
            const dataProperty = this.dataProperty;
            this.taskCategory.next(
              taskCategories.items.find(
                (element: any) =>
                  colData &&
                  dataProperty &&
                  colData[dataProperty] === element.id,
              ),
            );
          });
      },
    );
  }
}
